module.exports = "/_next/static/images/Cover-3f404ebef06d2a0d98e86d13bc4c68dd.webp";